"use client";

import { IconAccountLogout } from "@repo/assets/images";
import { CartContext } from "@repo/contexts/CartContext";
import { useUserLogoutEvent } from "@repo/lib/hooks/webengage";
import { logout } from "@repo/server-actions/account";
import { LoadingDots } from "@repo/ui";
import cx from "classnames";
import { signOut as nextAuthSignOut } from "next-auth/react";
import { useLocale, useTranslations } from "next-intl";
import { useCallback, useContext, useTransition } from "react";
function SubmitButton({
  onClick,
  pending
}) {
  const t = useTranslations("Common");
  return <button type="button" onClick={onClick} aria-disabled={pending} className={cx("ease border-lightgray text-supportiveGray4 hover:bg-icon-bg hover:text-supportiveBlack flex w-full rounded border p-2 transition-all duration-200 md:border-none md:p-4", {
    "cursor-not-allowed": pending
  })} data-sentry-component="SubmitButton" data-sentry-source-file="LogOutButton.jsx">
      <span className="flex w-full items-center">
        <IconAccountLogout className="me-2 fill-current" data-sentry-element="IconAccountLogout" data-sentry-source-file="LogOutButton.jsx" />
        <span className="font-medium">{t("Logout")}</span>
        {pending && <span className="ms-auto">
            <LoadingDots className="bg-black" />
          </span>}
      </span>
    </button>;
}
const LogOutButton = () => {
  const [isPending, startTransition] = useTransition();
  const {
    setCartTotalsInfo
  } = useContext(CartContext);
  const locale = useLocale();
  const {
    handleUserLogoutEvent
  } = useUserLogoutEvent();
  const handleSubmit = useCallback(async () => {
    startTransition(async () => {
      await logout(locale);
      setCartTotalsInfo(null);
      // Trigger user logout event for Webengage analytics
      await handleUserLogoutEvent();
      await nextAuthSignOut({
        redirectTo: `/login`
      });
    });
  }, [setCartTotalsInfo, locale, handleUserLogoutEvent]);
  return <SubmitButton onClick={handleSubmit} pending={isPending} data-sentry-element="SubmitButton" data-sentry-component="LogOutButton" data-sentry-source-file="LogOutButton.jsx" />;
};
export default LogOutButton;